"use client";

import { Coffee, Compass, Award, Newspaper, BookOpen, Star, Feather, Leaf } from "lucide-react";
export default function ComplianceStandards() {
  const stamps = [{
    label: "ISO 9001",
    year: "2023",
    icon: Newspaper,
    shape: "circle"
  }, {
    label: "GLOBAL SAFETY",
    year: "2022",
    icon: Compass,
    shape: "oval"
  }, {
    label: "TECH AUDIT",
    year: "2024",
    icon: Award,
    shape: "circle"
  }, {
    label: "DATA SECURE",
    year: "2023",
    icon: Star,
    shape: "oval"
  }, {
    label: "QUALITY ASSURED",
    year: "2024",
    icon: BookOpen,
    shape: "circle"
  }, {
    label: "ETHICAL OPS",
    year: "2023",
    icon: Feather,
    shape: "oval"
  }, {
    label: "GREEN CERT",
    year: "2022",
    icon: Coffee,
    shape: "circle"
  }, {
    label: "TRUST SEAL",
    year: "2024",
    icon: Leaf,
    shape: "oval"
  }];
  const loopStamps = [...stamps, ...stamps];
  return <section data-section-id="1391" id="compliance-standards" className="bg-background text-foreground relative overflow-hidden border-t border-b border-border/20">
      {}
      <div className="absolute top-4 left-4 md:top-6 md:left-8 font-mono text-[0.7rem] tracking-[0.1em] text-muted-foreground/70 z-10">
        CERT / 001-A
      </div>
      <div className="absolute bottom-8 right-4 md:bottom-10 md:right-8 font-mono text-[0.7rem] tracking-[0.1em] text-muted-foreground/70 z-10">
        STD / 992-B
      </div>

      <div className="py-16 md:py-20 px-6 md:px-10">
        {}
        <div className="max-w-7xl mx-auto text-center">
          <p className="font-default text-[0.8125rem] tracking-[0.18em] text-primary uppercase">
            § Nº 02 — Department of Compliance &amp; Standards
          </p>

          {}
          <div className="mt-5 mb-8 flex items-center justify-center gap-0">
            <div className="h-px w-32 md:w-48 bg-primary" />
            <div className="h-2 w-2 rounded-lg bg-primary" />
          </div>

          {}
          <p className="font-default italic text-foreground text-lg md:text-2xl leading-relaxed max-w-3xl mx-auto" style={{
          fontFamily: "var(--font-serif)"
        }}>
            Recognized globally for our commitment to operational excellence and rigorous industry standards —
          </p>
        </div>

        {}
        <div className="mt-12 md:mt-16 relative">
          {}
          <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-16 md:w-32 z-10" style={{
          background: "linear-gradient(to right, var(--background) 0%, transparent 100%)"
        }} />
          <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-16 md:w-32 z-10" style={{
          background: "linear-gradient(to left, var(--background) 0%, transparent 100%)"
        }} />

          <div className="press-marquee-track flex items-center gap-14 md:gap-14 w-max">
            {loopStamps.map((stamp, i) => {
            const Icon = stamp.icon;
            const isOval = stamp.shape === "oval";
            return <div key={i} data-index={i} className="press-stamp-item flex items-center gap-14 md:gap-14 shrink-0">
                  <div className="press-stamp group relative flex items-center justify-center shrink-0" style={{
                width: isOval ? "112px" : "72px",
                height: "72px"
              }}>
                    {}
                    <div className="absolute inset-0 border border-primary" style={{
                  borderRadius: isOval ? "8px" : "8px"
                }} />
                    {}
                    <div className="absolute border border-primary" style={{
                  top: "5px",
                  left: "5px",
                  right: "5px",
                  bottom: "5px",
                  borderRadius: isOval ? "8px" : "8px"
                }} />

                    {}
                    <svg className="absolute inset-0 w-full h-full pointer-events-none" viewBox={isOval ? "0 0 112 72" : "0 0 72 72"} style={{
                  overflow: "visible"
                }}>
                      <defs>
                        <path id={`top-arc-${i}`} d={isOval ? "M 18 36 A 38 28 0 0 1 94 36" : "M 14 36 A 22 22 0 0 1 58 36"} fill="none" />
                        <path id={`bottom-arc-${i}`} d={isOval ? "M 18 36 A 38 28 0 0 0 94 36" : "M 14 36 A 22 22 0 0 0 58 36"} fill="none" />
                      </defs>
                      <text fill="var(--foreground)" style={{
                    fontFamily: "var(--font-mono)",
                    fontSize: isOval ? "7px" : "6px",
                    letterSpacing: "0.15em",
                    fontWeight: 500
                  }}>
                        <textPath href={`#top-arc-${i}`} startOffset="50%" textAnchor="middle">
                          {stamp.label}
                        </textPath>
                      </text>
                      <text fill="var(--primary)" style={{
                    fontFamily: "var(--font-mono)",
                    fontSize: "6px",
                    letterSpacing: "0.15em",
                    fontStyle: "italic"
                  }}>
                        <textPath href={`#bottom-arc-${i}`} startOffset="50%" textAnchor="middle">
                          {stamp.year}
                        </textPath>
                      </text>
                    </svg>

                    {}
                    <Icon className="size-5 text-primary relative z-10" strokeWidth={1.5} />
                  </div>

                  {}
                  <div className="flex items-center gap-2 shrink-0">
                    <span className="h-1 w-1 rounded-lg bg-primary/70" />
                    <span className="h-1 w-1 rounded-lg bg-primary/40" />
                    <span className="h-1 w-1 rounded-lg bg-primary/70" />
                  </div>
                </div>;
          })}
          </div>
        </div>
      </div>

      {}
      <div className="h-4 w-full" style={{
      backgroundImage: "linear-gradient(to right, var(--primary) 0, var(--primary) 4px, transparent 4px, transparent 10px)",
      backgroundSize: "10px 2px",
      backgroundRepeat: "repeat-x",
      backgroundPosition: "center"
    }} />

      <style>{`
        @keyframes pressMarqueeScroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .press-marquee-track {
          animation: pressMarqueeScroll 40s linear infinite;
        }
        .press-marquee-track:hover {
          animation-play-state: paused;
        }
        .press-stamp {
          transition: transform 700ms cubic-bezier(0.65, 0, 0.35, 1);
        }
        .press-stamp:hover {
          transform: rotate(-6deg);
        }
      `}</style>
    </section>;
}